import { Row, Col, Form, Button, Modal } from 'react-bootstrap';
import { useState } from 'react';
import Swal from "sweetalert2";
import Select from 'react-select';


const EditUserModal = ({ show, requestClose, userID }) => {

    //ENV VARIABLE
    const apiUrl = process.env.REACT_APP_API_URL;
    const backendAPI_Key = process.env.REACT_APP_API_KEY;

    //SESSION OBJECT
    const sessionUser = JSON.parse(sessionStorage.getItem("userSession"));

    //INPUTS CONTROLS
    const [name, setName] = useState(null);
    const [lastName, setLastName] = useState(null);
    const [userName, setUserName] = useState(null);
    const [userGroup, setUserGroup] = useState(null);
    const [userMail, setUserMail] = useState(null);
    const [userCompany, setUserCompany] = useState(null);


    //
    const [userGroupsCombo, setUserGroupsCombo] = useState([]);


    const getUsersGroupsListing = async () =>{

        const endpoint = "getUsersGroupsListing";
        
        const response = await fetch(apiUrl + endpoint,
        {
            method: "GET",
            headers: {"Content-Type": "application/json", "X-API-KEY" : backendAPI_Key}
        });

        const responseContent = await response.json();
        console.log(responseContent);

        setUserGroupsCombo(responseContent);


    } //END FUNCTION


    const getUserInformation = async () => {

        const endpoint = `getUserInformation?userID=${userID}`;
        
        const response = await fetch(apiUrl + endpoint,
        {
            method: "GET",
            headers: {"Content-Type": "application/json", "X-API-KEY" : backendAPI_Key}
        });

        const responseContent = await response.json();
        console.log(responseContent);

        //SETUP VARIABLES
        setName(responseContent.customer_name);
        setLastName(responseContent.lastname);
        setUserName(responseContent.username);
        setUserGroup(responseContent.group_id);
        setUserCompany(responseContent.is_company);
        setUserMail(responseContent.email);

        //setUserListing(responseContent);


    } //END FUNCTION


    const editUser = async () => {

        //MAIN VALIDATION
        if(!name || !userName || !userGroup){

            //Show message sweet alert
            Swal.fire({
                title: "Datos Faltantes",
                text: "Faltan datos obligatorios por completar.",
                icon: "warning",
                confirmButtonText: "OK"
            });

            return;
        }//


        const metadata = {
            "id" : userID,
            "customer_name": name ? name.replace(/[\t\\']/g, '').trim() : "",
            "lastname": lastName ? lastName.replace(/[\t\\']/g, '').trim() : "",
            "email": userMail ? userMail.replace(/[\t\\']/g, '').trim() : "",
            "username": userName ? userName.replace(/[\t\\']/g, '').trim() : "",
            "group_id": userGroup,
            "observations":""
        };

        //
        if(userGroup === 2001){ metadata.is_company = userCompany; }
        else { metadata.is_company = 0; }

        console.log(metadata);
        
        const endpoint = "editUser";

        const response = await fetch(apiUrl + endpoint,
        {
            method: "POST",
            headers: {"Content-Type": "application/json", "X-API-KEY" : backendAPI_Key},
            body: JSON.stringify(metadata)
        });

        const responseContent = await response.json();

        if(responseContent.code == 403){

            Swal.fire({
                title: "Error!",
                text: responseContent.message,
                icon: "error",
                confirmButtonText: "OK"
            });

        } else if(responseContent.code == 500){

            //Show message sweet alert
            Swal.fire({
                title: "Error!",
                text: responseContent.message,
                icon: "error",
                confirmButtonText: "OK"
            });


        } else if(responseContent.code == 200){

            //Show message sweet alert
            Swal.fire({
                title: "¡Éxito!",
                text: "Operación realizada exitosamente.",
                icon: "success",
                confirmButtonText: "OK"
            });

            //CLOSE MODAL
            requestClose(false);

        }

    } //
    

    const onModalShow = () => {

        getUsersGroupsListing(); 

        getUserInformation();

    } //END FUNCTION

    

    return (
        <>
        <Modal show={show} onShow={onModalShow} onHide={requestClose} className={'mainOrderModal'}>
            <Modal.Header closeButton style={{borderTop:'10px solid #404661'}}>
                <Modal.Title className={'newOrderTitle'}>Editar Usuario</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                <Row>

                    <Col xs={12}>
                        <Form.Group>
                             <Form.Label className={'newOrderlabels'}>Grupo</Form.Label>
                             <Form.Select value={userGroup} style={{fontSize:"13px"}} onChange={(e)=>{setUserGroup(e.target.value); }}>
                               <option style={{fontSize:"14px"}}>Seleccione...</option>
                                {userGroupsCombo.map((item)=>{

                                    return(
                                       <option style={{fontSize:"14px"}}  value={item.id}>{item.group_name}</option>
                                    )

                                })}
                               
                            </Form.Select> <br />
                        </Form.Group>
                    </Col>

                    {userGroup === 2001 ? (
                        <Col xs={12}>
                            <Form.Label className={'newOrderlabels'}>Tipo de Cliente</Form.Label>
                                <Form.Select value={userCompany} style={{fontSize:"14px"}} onChange={(e)=>{setUserCompany(e.target.value); }}>
                                    <option style={{fontSize:"14px"}} value="1" selected>Persona Jurídica</option>
                                    <option style={{fontSize:"14px"}} value="0">Consumidor Final</option>
                                </Form.Select> <br />
                        </Col>
                    ) : "" }

                    <Col xs={12}>
                        <Form.Group>
                             <Form.Label className={'newOrderlabels'}>
                                { userGroup === 2001 ? (userCompany === 0 ? "Nombre Cliente" : "Empresa") : "Nombre Usuario" }
                            </Form.Label>
                            <Form.Control 
                                type="text" 
                                value={name}
                                placeholder={ userGroup === "2001" ? (userCompany === "0" ? "Nombre Cliente..." : "Empresa...") : "Nombre Usuario..." }
                                onChange={(event)=> setName(event.target.value)} /><br />
                        </Form.Group>
                    </Col>

                    <Col xs={12}>
                        <Form.Group>
                             <Form.Label className={'newOrderlabels'}>Username</Form.Label>
                             <Form.Control 
                             type="text" 
                             placeholder="Username (login)" 
                             value={userName}
                             onChange={(event)=> setUserName(event.target.value)} /><br />
                        </Form.Group>
                    </Col>
                    

                    <Col xs={12}>
                        <Form.Group>
                             <Form.Label className={'newOrderlabels'}>Contacto / E-Mail</Form.Label>
                             <Form.Control 
                             type="text" 
                             placeholder="E-Mail" 
                             value={userMail}
                             onChange={(event)=> setUserMail(event.target.value)} /><br />
                        </Form.Group>
                    </Col>

                    
                </Row>
                </Form>
            </Modal.Body>
            <Modal.Footer>
            <Button variant="danger" onClick={requestClose} size='sm'>
                Cerrar Ventana
            </Button>
            <Button 
                variant="success" 
                size='sm'
                onClick={editUser}
                >

                Actualizar Datos
            </Button>
            </Modal.Footer>
        </Modal>
        </>
    );
}

export default EditUserModal;